import { createGlobalState } from "@vueuse/core";
import { ref } from "vue";

interface RecentlyCreatedEntity {
  id: number
  type: "task" | "report"
  createdAt: number // timestamp
}

const CLEANUP_INTERVAL = 30000; // 30 seconds

export const useRecentlyCreatedEntities = createGlobalState(() => {
  const entities = ref<RecentlyCreatedEntity[]>([]);

  function addEntity(id: number, type: "task" | "report") {
    entities.value.push({
      id,
      type,
      createdAt: Date.now(),
    });

    // Clean up old entries after a delay
    setTimeout(() => {
      cleanupOldEntries();
    }, CLEANUP_INTERVAL);
  }

  function cleanupOldEntries() {
    const now = Date.now();
    entities.value = entities.value.filter(
      entity => now - entity.createdAt < CLEANUP_INTERVAL,
    );
  }

  function hasEntity(id: number, type: "task" | "report"): boolean {
    cleanupOldEntries();
    return entities.value.some(
      entity => entity.id === id && entity.type === type,
    );
  }

  return {
    addEntity,
    hasEntity,
  };
});
